import { useRouteError as useReactRouterError } from 'react-router-dom';
import environment from '@/environments/environment';

/**
 * Safe wrapper for useRouteError that only works with React Router's Data API
 * (createBrowserRouter). In microfrontend mode, this returns null.
 *
 * @returns Route error if available, null otherwise
 */
export const useRouteError = () => {
  try {
    // Only use useRouteError in standalone mode with createBrowserRouter
    if (environment.IS_RUNNING_STAND_ALONE) {
      return useReactRouterError();
    }
    return null;
  } catch (error) {
    // If useRouteError throws (not in Data API context), return null
    return null;
  }
};
